"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSelectThemeOptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const material_1 = require("@mui/material");
const fontawesome_icon_1 = require("../../../fontawesome-icon");
exports.MuiSelectThemeOptions = {
    defaultProps: {
        IconComponent: (props) => (0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleDown, ...props }),
        size: "medium",
    },
    styleOverrides: {
        select: ({ theme }) => ({
            display: "flex",
            alignItems: "center",
            // LIST ITEM ICON
            [`& .${material_1.listItemIconClasses.root}`]: {
                color: theme.palette.gray[50],
                minWidth: "unset",
                marginRight: 12,
                alignItems: "center",
            },
            // LIST ITEM AVATAR
            [`& .${material_1.listItemAvatarClasses.root}`]: {
                border: "2px solid transparent",
                marginRight: "12px",
                borderRadius: "50%",
                minWidth: "unset",
            },
            // LIST ITEM TEXT
            [`& .${material_1.listItemTextClasses.primary}`]: {
                ...theme.typography.smallTextLabels,
                fontWeight: 500,
                color: theme.palette.gray[80],
            },
            [`& .${material_1.listItemTextClasses.secondary}`]: {
                ...theme.typography.microText,
                marginTop: "2px",
                fontWeight: 500,
                color: theme.palette.gray[50],
            },
            // LIST ITEM SECONDARY ACTION
            [`& .${material_1.listItemSecondaryActionClasses.root}`]: {
                right: theme.spacing(4.5),
                ...theme.typography.smallTextLabels,
                fontWeight: 500,
                color: theme.palette.gray[50],
            },
            "&:hover": {
                backgroundColor: theme.palette.gray[10],
            },
        }),
        outlined: ({ theme }) => ({
            [`& ~ .${material_1.outlinedInputClasses.notchedOutline}, &:hover ~ .${material_1.outlinedInputClasses.notchedOutline}`]: {
                borderColor: theme.palette.gray[30],
                boxShadow: theme.boxShadows.xs,
            },
            [`&:focus ~ .${material_1.outlinedInputClasses.notchedOutline}`]: {
                border: `1px solid ${theme.palette.blue[60]}`,
            },
        }),
        icon: ({ theme }) => ({
            color: theme.palette.gray[50],
            fontSize: 16,
            right: theme.spacing(1.5),
        }),
    },
};
